import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import ParksHeader from "../../components/ManageParks/ParksHeader";
import ParksProductTable from "../../components/ManageParks/ParksProductTable";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import {
  getFormattedProductList,
  getFormattedProductListForDropdown,
} from "../../helper";
import { fetchAllProducts } from "../../services/productService";
import CreateHeader from "../../components/ManageParks/CreateHeader";
import {
  addSoldout,
  cancelSoldout,
  fetchOutletFromId,
  getSoldoutList,
} from "../../services/outletsService";
import { useParams } from "react-router-dom";
import { getSettings } from "../../services/settingsService";
import SoldOutModal from "../../components/ManageParks/SoldOutModal";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import SoldoutTable from "../../components/ManageParks/SoldoutTable";
import CancelSoldout from "../../components/ManageParks/CancelSoldout";
import { useLoadContext } from "../../contexts/LoadContext";

const Parks = () => {
  const [data, setData] = useState([]);
  const [duration, setDuration] = useState({});
  const [outlet, setOutlet] = useState({
    name: "",
    shortName: "",
  });
  const navigate = useNavigate();
  const [isFailureModal, setIsFailureModal] = useState(false);
  const [isTableDataLoading, setTableLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  let [soldoutData, setSoldoutData] = useState({
    date: "",
    outlet: "",
    outletShortName: "",
    isAllIncluded: false,
    products: [],
    comment: "",
  });

  const [errors, setErrors] = useState({
    comment: "",
    date: "",
    product: "",
  });

  const [soldOutPopup, setSoldOutPopup] = useState(false);
  const [confirmCancelSoldoutPopup, setConfirmCancelSoldoutPopupPopup] =
    useState(false);
  const [soldout, setSoldout] = useState([]);
  const { setLoader } = useLoadContext();

  let { id } = useParams();

  useEffect(() => {
    fetchParks();
  }, []);

  const fetchParks = async () => {
    setTableLoader(true);
    try {
      let outlet = await fetchOutletFromId(id);
      let settings = await getSettings("cms");
      let soldout = await getSoldoutList(outlet?.data?.data?._id);

      const durationObj = settings?.data?.data?.aqua?.duration.map(
        (item: number) => {
          return { path: item, label: `${item} min` };
        }
      );

      setSoldout(soldout?.data?.data);
      setDuration(durationObj);
      setOutlet(outlet?.data?.data);
      let { data } = await fetchAllProducts(outlet?.data?.data?.shortName, id);

      if (data.code === 200) {
        let formattedData = getFormattedProductList(
          JSON.parse(JSON.stringify(data.data)),
          outlet?.data?.data?.shortName
        );
        let formattedDataforDD = [
          { label: "All Products", value: "all", selected: false },
          ...getFormattedProductListForDropdown(
            JSON.parse(JSON.stringify(data.data)),
            outlet?.data?.data?.shortName
          ),
        ];
        console.log(formattedDataforDD);
        setSoldoutData({
          ...soldoutData,
          // @ts-ignore
          products: formattedDataforDD,
          outletShortName: outlet?.data?.data?.shortName,
          outlet: outlet?.data?.data?._id,
        });
        setTableLoader(false);
        setData(formattedData);
      }
    } catch (error: any) {
      setTableLoader(false);
      if (navigator.onLine) {
        setIsFailureModal(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleEdit = (prodId: string) => {
    navigate(
      `/admin/edit-product/${prodId}?outletId=${id}&product=${outlet?.shortName}`
    );
  };

  const handleSoldoutChange = (e: any) => {
    setSoldoutData({ ...soldoutData, [e.target.name]: e.target.value });
    if (e.target.name === "comment" || e.target.name === "date") {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const validateObject = (obj: any) => {
    let error = {
      date: "",
      comment: "",
      product: "",
    };
    if (obj.date === "") {
      error["date"] = "Date is required";
    }

    if (obj.comment.trim() === "") {
      error["comment"] = "Comment is required";
    }

    console.log(obj.isAllIncluded);
    console.log(obj.products);

    if (
      !obj?.isAllIncluded &&
      obj.products.filter((prd: any) => prd.selected).length === 0
    ) {
      error["product"] = "Products must be selected";
    }

    return {
      hasError: !Object.values(error).every((value) => value === ""),
      errorObj: error,
    };
  };

  const handleSoldoutSubmit = () => {
    let err = validateObject(soldoutData);
    console.log(err);
    if (err.hasError) {
      setErrors({ ...err.errorObj });
    } else {
      let postableObj = { ...soldoutData };
      postableObj.date = dayjs(postableObj?.date).format("YYYY-MM-DD");
      postableObj.products = JSON.parse(
        JSON.stringify(
          postableObj.products
            .filter((prd: any) => prd.selected)
            .map((prd: any) => ({
              productId: prd.value,
              productName: prd.label,
            }))
        )
      );
      try {
        setLoader(true);
        let res = addSoldout(postableObj);
        setSoldOutPopup(false);
        fetchParks();
      } catch (error: any) {
        toast.error(error?.message);
      } finally {
        setLoader(false);
      }
    }
  };

  const handleProductSelect = (val: any) => {
    let formData = { ...soldoutData };
    let selectedProduct: string[] = soldoutData.products;

    if (val.value === "all") {
      let updatedProd = selectedProduct.map((prod: any) =>
        prod.value === "all"
          ? { ...prod, selected: true }
          : { ...prod, selected: false }
      );
      setSoldoutData({
        ...formData,
        // @ts-ignore
        products: updatedProd,
        isAllIncluded: true,
      });
    } else {
      let updatedProd = selectedProduct.map((prod: any) =>
        val.value === prod.value ? { ...prod, selected: !prod.selected } : prod
      );

      updatedProd[0].selected = false;

      setSoldoutData({
        ...formData,
        // @ts-ignore
        products: updatedProd,
        isAllIncluded: false,
      });
    }
    setErrors({ ...errors, product: "" });
  };

  const handleCancelSoldout = async (id: any) => {
    setConfirmCancelSoldoutPopupPopup(id);
  };

  const handleConfirmCancelSoldout = async () => {
    setLoader(true);
    try {
      let res = await cancelSoldout(confirmCancelSoldoutPopup);
      setConfirmCancelSoldoutPopupPopup(false);

      fetchParks();
    } catch (err: any) {
      toast.error(err?.message);
    } finally {
      setLoader(false);
    }
  };

  return (
    <LwwPageContainer>
      <ParksHeader label={outlet.name} />
      <CreateHeader
        label="Product pricing"
        outletId={id}
        product={outlet?.shortName}
        onSoldoutClick={() => setSoldOutPopup(true)}
      />
      <ParksProductTable
        data={data}
        onEdit={handleEdit}
        isTableDataLoading={isTableDataLoading}
        outlet={outlet?.shortName}
        durationObj={duration}
      />
      <div style={{ paddingTop: "1.5rem", paddingBottom: "1rem" }}>
        <CreateHeader
          hideButtons={true}
          label="Sold out"
          outletId={id}
          product={outlet?.shortName}
          onSoldoutClick={() => setSoldOutPopup(true)}
        />
      </div>
      <SoldoutTable
        data={soldout}
        onCancelSoldout={handleCancelSoldout}
        isTableDataLoading={isTableDataLoading}
      />
      {isFailureModal && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailureModal}
          onSubmit={() => setIsFailureModal(false)}
        />
      )}
      {soldOutPopup && (
        <SoldOutModal
          onToggleModalState={(val) => setSoldOutPopup(val)}
          data={soldoutData}
          errors={errors}
          onSoldoutChange={handleSoldoutChange}
          onProductSelect={handleProductSelect}
          onSoldoutSubmit={handleSoldoutSubmit}
        />
      )}
      {confirmCancelSoldoutPopup && (
        <CancelSoldout
          onToggleModalState={(val) => setConfirmCancelSoldoutPopupPopup(val)}
          onCancelSoldoutConfirm={handleConfirmCancelSoldout}
        />
      )}
    </LwwPageContainer>
  );
};

const LwwPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default Parks;
